(function () {
  var sizeData = {
    small:  { name: 'Small',  chews: 1, jarDays: '30 days',  price30: 34.95, price90: 79.90 },
    medium: { name: 'Medium', chews: 2, jarDays: '15 days',  price30: 54.95, price90: 129.90 },
    large:  { name: 'Large',  chews: 3, jarDays: '10 days',  price30: 69.95, price90: 169.90 },
    giant:  { name: 'Giant',  chews: 4, jarDays: '7–8 days', price30: 84.95, price90: 199.90 }
  };

  var singleJarPrice = 34.95;

  function money(value) {
    return '$' + value.toFixed(2);
  }

  function initialize(root) {
    if (!root || root.dataset.sizeOfferInitialized === 'true') return;
    root.dataset.sizeOfferInitialized = 'true';

    var sizeButtons = root.querySelectorAll('[data-offer-size]');
    var plans = root.querySelectorAll('[data-offer-plan]');
    var tastePlan = root.querySelector('[data-offer-plan="taste"]');
    var routine30Plan = root.querySelector('[data-offer-plan="routine30"]');
    var readout = root.querySelector('[data-offer-readout]');
    var sizeProperty = root.querySelector('[data-offer-size-property]');
    var planProperty = root.querySelector('[data-offer-plan-property]');
    var variantSelect = root.querySelector('[data-pdp-variant]');
    var packageVariantMode = variantSelect && variantSelect.options.length > 1;
    var pageRoot = root.closest('[data-itchova-pdp]');
    var primaryBuyButton = root.querySelector('.itchova-pdp__add');
    var mobileBuyButton = pageRoot && pageRoot.querySelector('.itchova-pdp__mobile-buy-button');
    var selectedSize = 'medium';

    function normalizeTitle(value) {
      return String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();
    }

    function selectPackageVariant(title) {
      if (!packageVariantMode || !title) return null;

      var target = normalizeTitle(title);
      var matchedOption = Array.prototype.find.call(variantSelect.options, function (option) {
        return normalizeTitle(option.dataset.variantTitle || option.textContent) === target;
      });

      if (!matchedOption) return null;
      variantSelect.value = matchedOption.value;
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      return matchedOption;
    }

    function setPlan(planName, details) {
      var plan = root.querySelector('[data-offer-plan="' + planName + '"]');
      if (!plan) return;

      plan.dataset.quantity = String(details.quantity);
      plan.dataset.price = money(details.price);
      plan.dataset.buttonLabel = details.buttonLabel;
      plan.dataset.variantTitle = details.variantTitle || '';

      var title = plan.querySelector('[data-offer-plan-title]');
      var price = plan.querySelector('[data-offer-plan-price]');
      var priceContext = plan.querySelector('[data-offer-saving]');
      var dailyCost = plan.querySelector('[data-offer-daily-cost]');
      if (title) title.textContent = details.title;
      if (price) price.textContent = money(details.price);
      if (priceContext) priceContext.textContent = details.priceContext || '';
      if (dailyCost) dailyCost.textContent = details.dailyCost || '';
    }

    function refreshSelectedPlan() {
      var selectedPlan = root.querySelector('[data-offer-plan].is-selected') || plans[0];
      if (!selectedPlan) return;

      var quantityInput = root.querySelector('[data-pdp-quantity]');
      var buttonLabel = root.querySelector('[data-pdp-button-label]');
      var buttonPrice = root.querySelector('[data-pdp-button-price]');
      var mobileLabel = pageRoot && pageRoot.querySelector('[data-pdp-mobile-label]');
      var mobilePrice = pageRoot && pageRoot.querySelector('[data-pdp-mobile-price]');
      var matchedVariant = selectPackageVariant(selectedPlan.dataset.variantTitle);
      var packageAvailable = !packageVariantMode || Boolean(matchedVariant && !matchedVariant.disabled);

      if (quantityInput) quantityInput.value = packageVariantMode ? '1' : (selectedPlan.dataset.quantity || '1');
      if (buttonLabel) buttonLabel.textContent = packageAvailable ? (selectedPlan.dataset.buttonLabel || '') : 'Package unavailable';
      if (buttonPrice) buttonPrice.textContent = packageAvailable ? (selectedPlan.dataset.price || '') : '';
      if (mobileLabel) mobileLabel.textContent = packageAvailable ? (selectedPlan.dataset.buttonLabel || '') : 'Package unavailable';
      if (mobilePrice) mobilePrice.textContent = packageAvailable ? (selectedPlan.dataset.price || '') : '';
      if (primaryBuyButton) primaryBuyButton.disabled = !packageAvailable;
      if (mobileBuyButton) mobileBuyButton.disabled = !packageAvailable;
      if (planProperty) planProperty.value = selectedPlan.dataset.planLabel || '';
    }

    function applySize(sizeKey) {
      var size = sizeData[sizeKey];
      if (!size) return;
      selectedSize = sizeKey;
      if (sizeProperty) sizeProperty.value = size.name;

      if (tastePlan) {
        tastePlan.hidden = sizeKey === 'small';
        tastePlan.setAttribute('aria-hidden', sizeKey === 'small' ? 'true' : 'false');

        if (sizeKey === 'small' && tastePlan.classList.contains('is-selected') && routine30Plan) {
          plans.forEach(function (plan) {
            plan.classList.remove('is-selected');
            plan.setAttribute('aria-pressed', 'false');
          });
          routine30Plan.classList.add('is-selected');
          routine30Plan.setAttribute('aria-pressed', 'true');
        }
      }

      sizeButtons.forEach(function (button) {
        var isSelected = button.dataset.offerSize === selectedSize;
        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      var jars30 = size.chews;
      var jars90 = size.chews * 3;
      var perJar90 = size.price90 / jars90;

      if (readout) {
        readout.innerHTML =
          '<span>Your dog: <b>' + size.name + '</b></span>' +
          '<span>Daily serving: <b>' + size.chews + ' ' + (size.chews === 1 ? 'chew' : 'chews') + '</b></span>' +
          '<span>One jar lasts <b>' + size.jarDays + '</b></span>' +
          '<span class="is-accent">A real 90 days is ' + jars90 + ' jars</span>';
      }

      setPlan('taste', {
        quantity: 1,
        price: singleJarPrice,
        buttonLabel: 'Start with 1 jar',
        title: '1 jar · lasts ' + size.jarDays,
        variantTitle: 'Taste Test — 1 Jar'
      });

      setPlan('routine90', {
        quantity: jars90,
        price: size.price90,
        buttonLabel: 'Buy the 90-day supply',
        title: '90 days · ' + jars90 + ' jars · ' + (jars90 * 30) + ' soft chews',
        variantTitle: size.name + ' — 90 Days — ' + jars90 + ' ' + (jars90 === 1 ? 'Jar' : 'Jars'),
        priceContext: money(perJar90) + ' / jar · reg. ' + money(singleJarPrice),
        dailyCost: money(size.price90 / 90) + ' / day'
      });

      setPlan('routine30', {
        quantity: jars30,
        price: size.price30,
        buttonLabel: 'Buy 30 days',
        title: '30 days · ' + jars30 + ' ' + (jars30 === 1 ? 'jar' : 'jars') + ' · ' + (jars30 * 30) + ' soft chews',
        variantTitle: size.name + ' — 30 Days — ' + jars30 + ' ' + (jars30 === 1 ? 'Jar' : 'Jars')
      });

      refreshSelectedPlan();
    }

    sizeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        applySize(button.dataset.offerSize);
      });
    });

    plans.forEach(function (plan) {
      plan.addEventListener('click', refreshSelectedPlan);
    });

    applySize(selectedSize);
  }

  function initializeAll(scope) {
    (scope || document).querySelectorAll('[data-itchova-size-offer]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
